import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import CategoryHeader from '../../components/CategoryHeader';
import Section from '../../components/Section';
import CategoryToolTile from '../../components/CategoryToolTile';
import fireBatchedImpressions from '../../lib/BatchImpressions';
import { clientLogger } from '../../../../lib/logger';

import { AMPLITUDE } from '../../../../lib/constants';

const { CATEGORY_APP_TILE_CLICK } = AMPLITUDE;

const Category = props => {
  const {
    category: {
      content: {
        location = '',
        categoryTitle,
        categoryHeader,
        categoryBody,
        categoryImageUrl,
        categoryImageUrlVariant,
        categoryFPTI,
        PSImpressionUrl
      } = {},
      sections,
      tools = []
    } = {},
    fptiClick,
    fptiImpression,
    toolTileProps,
    staticContext,
    app,
    isColoredIconsEligible
  } = props;

  useEffect(() => {
    const { app: { csrf = '' } = {} } = toolTileProps;
    const links = [];
    links.push(PSImpressionUrl);
    if (Array.isArray(sections)) {
      sections.forEach(({ content = {}, tools: sectionTools = [] }) => {
        links.push(content.PSImpressionUrl);
        sectionTools.forEach(({ PSImpressionUrl = '' }) => {
          links.push(PSImpressionUrl);
        });
      });
    } else {
      tools.forEach(({ PSImpressionUrl = '' }) => {
        links.push(PSImpressionUrl);
      });
    }
    fireBatchedImpressions(links, csrf);
  }, []);

  const path = `/appcenter/${location}`;

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    sectionRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: categoryFPTI,
        categoryRank,
        sectionRank,
        appKey,
        rank,
        priorityScore,
        amplitude: true,
        event_name: CATEGORY_APP_TILE_CLICK
      });
      fetch(PSUrl);
    };
  };

  // only some category pages have sections
  const renderSections = sections => {
    if (Array.isArray(sections)) {
      return sections.map(({ content, tools }, index) => {
        return (
          <Section
            key={`sections-item-${index}`}
            path={path}
            content={content}
            tools={tools}
            toolTileProps={toolTileProps}
            fptiImpression={fptiImpression}
            fptiClick={fptiClick}
          />
        );
      });
    }
    if (!tools || tools.length === 0) {
      if (staticContext?.req?.user) {
        clientLogger.warn(
          `${location} Redirecting: Category is empty`,
          JSON.stringify({
            country: app?.legalCountry,
            locale: app?.context?.locale?.locale,
            loggedIn: app?.fptiData?.lgin
          })
        );
        staticContext.url = '/merchantapps/appcenter';
      } else {
        staticContext.url = '/merchantapps/appcenter/notfound';
      }
    }
    return (
      <div className="section-tools">
        {tools.map((t, index) => (
          <CategoryToolTile
            key={`category-tool-item-${index}`}
            handleClickTool={handleClickTool}
            tool={t}
            path={path}
            toolTileProps={toolTileProps}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
          />
        ))}
      </div>
    );
  };

  const imageUrl =
    isColoredIconsEligible && categoryImageUrlVariant
      ? categoryImageUrlVariant
      : categoryImageUrl;

  return (
    <div id="appcenter-category">
      <CategoryHeader
        title={categoryTitle}
        subtitle={categoryHeader}
        body={categoryBody}
        imageUrl={imageUrl}
      />
      <div className="sections">{renderSections(sections)}</div>
    </div>
  );
};

Category.displayName = 'category';

Category.propTypes = {
  category: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  staticContext: PropTypes.object,
  app: PropTypes.object,
  isColoredIconsEligible: PropTypes.bool
};

export default Category;
